import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import network from "../../../../../selectors/network";
import { getLocation } from "../../../../../queries/locations";

interface Params {
  id: string | number | null | undefined;
}
export default function useCoreLocation({ id }: Params) {
  const networkHeaders = useSelector(network.defaultHeaders);

  const queryKey = ["Locations", id?.toString()] as const;
  const locationQuery = useQuery(queryKey, getLocation(networkHeaders), {
    queryFnParamsFilter: (key) => [key[1]],
    enabled: !!id,
  });

  return {
    queryKey: queryKey,
    isLoading: locationQuery.isLoading,
    data: locationQuery.data,
  };
}
